import React from "react";
import TitoloColore from "../commons/TitoloColore";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import calendario from "../images/2026-27.png"
import Space from "../commons/Space";
import TitoloSezioni from "../commons/TitoloSezioni";
import SpaceL from "../commons/SpaceL";
import fin from "../images/logo/Fin.svg";
import uisp from "../images/logo/Logo_UISP.png";
import libertas from "../images/logo/libertas.jpeg";
import "../styles/Calendario.css"


function Calendario() {
    return(
        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Calendario"} backgroundColor={"#003F83"} />
            <div className="text-center d-flex flex-column align-items-center">
                <div className="d-none d-sm-block"><Space /></div>
                <div className="d-block d-sm-none"><SpaceL /></div>
                <div style={{display: "flex", flexDirection: "column", width: "80%"}}>
                    <a style={{alignSelf: "end"}} href={calendario} download>
                        <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                    </a>
                    <img className="d-none d-sm-block" src={calendario} style={{width: "60%", margin: "auto", boxShadow: "15px 15px 20px rgba(0, 0, 0, 0.5)"}}></img>
                    <img

                        className="d-block d-sm-none zoomable-image"
                        src={calendario}
                        style={{
                            width: "100%",
                            margin: "auto",
                            boxShadow: "15px 15px 20px rgba(0, 0, 0, 0.5)",
                            touchAction: "manipulation" // Evita il double-tap zoom della pagina
                        }}
                    />

                </div>

            </div>
            <Space />
        </div>
    )
}

export default Calendario